// Site-wide tooltips for elements with a data-tooltip attribute, e.g. <img data-tooltip="Jane Doe">.
// A single delegated listener, so elements rendered later (React, ag-grid, Turbo visits) need no setup.
// Uses the Bootstrap tooltip markup to look the same as the other tooltips. Text only, never HTML.

const SELECTOR = '[data-tooltip]';
const OFFSET = 6;

let tooltip = null;
let currentTarget = null;

const getTooltip = () => {
  if (tooltip?.isConnected) return tooltip;

  tooltip = document.createElement('div');
  tooltip.className = 'tooltip top data-tooltip';
  tooltip.setAttribute('role', 'tooltip');
  tooltip.innerHTML = '<div class="tooltip-arrow"></div><div class="tooltip-inner"></div>';
  document.body.appendChild(tooltip);
  return tooltip;
};

const show = (target) => {
  const text = target.getAttribute('data-tooltip');
  if (!text) return;

  const el = getTooltip();
  el.querySelector('.tooltip-inner').textContent = text;
  el.classList.add('in');

  const rect = target.getBoundingClientRect();
  const left = rect.left + window.scrollX + (rect.width - el.offsetWidth) / 2;
  const top = rect.top + window.scrollY - el.offsetHeight - OFFSET;
  el.style.left = `${Math.max(window.scrollX, left)}px`;
  el.style.top = `${top}px`;

  if (!target.hasAttribute('aria-label')) target.setAttribute('aria-label', text);
  currentTarget = target;
};

const hide = () => {
  tooltip?.classList.remove('in');
  currentTarget = null;
};

const onEnter = (event) => {
  const target = event.target.closest?.(SELECTOR);
  if (target && target !== currentTarget) show(target);
};

const onLeave = (event) => {
  if (!currentTarget) return;
  // Moving within the same element (e.g. between its children) keeps the tooltip open
  if (event.relatedTarget && currentTarget.contains(event.relatedTarget)) return;
  if (event.target.closest?.(SELECTOR) === currentTarget) hide();
};

if (!window.dataTooltipInitialized) {
  window.dataTooltipInitialized = true;

  document.addEventListener('mouseover', onEnter);
  document.addEventListener('focusin', onEnter);
  document.addEventListener('mouseout', onLeave);
  document.addEventListener('focusout', onLeave);
  window.addEventListener('scroll', hide, true);
  document.addEventListener('turbo:before-render', hide);
}
